import Tile from '../../Tile';
import React, { useState } from 'react';
import SectionHeader from './SectionHeader';
import { GeoAIFeatureTypesEnum } from 'Enums';
import GeoAIModal from 'components/GeoAIModal';
import FlexContainer from '../../FlexContainer';
import { useDispatch, useSelector } from "react-redux";

import tree_canopy from '../../../static/img/canopy.jpg';
import car_detection from '../../../static/img/car_detection.jpg';
import pool_detection from '../../../static/img/pool_detection.jpg';
import building_footprint from '../../../static/img/building_footprint.jpg';

const Locate = () => {
  const dispatch = useDispatch();
  const [featureType, setFeatureType] = useState();
  
  const showGeoAIModal = useSelector(state => state.settings.showGeoAIModal);

  const showDetectModal = (feature_type) => {
    dispatch({ type: 'TOGGLE_GEOAI_MODAL', show: true });
    setFeatureType(feature_type);
  }

  return (
    <>
      <SectionHeader heading="GeoAI" />
      <FlexContainer>
        <Tile title="Building Detection" bg={building_footprint} onAdd={() => showDetectModal(GeoAIFeatureTypesEnum.Building)}>
          <p className="category">GeoAI</p>
        </Tile>
        <Tile title="Car Detection" bg={car_detection} onAdd={() => showDetectModal(GeoAIFeatureTypesEnum.Car)}>
          <p className="category">GeoAI</p>
        </Tile>
        <Tile title="Pool Detection" bg={pool_detection} onAdd={() => showDetectModal(GeoAIFeatureTypesEnum.Pool)}>
          <p className="category">GeoAI</p>
        </Tile>
        <Tile title="Tree Canopy Detection" bg={tree_canopy}>
          <p className="category">GeoAI</p>
        </Tile>
      </FlexContainer>
      {
        showGeoAIModal && <GeoAIModal featureType={featureType}/>
      }
    </>
  )
}

export default Locate;